// 本地环境
// const admin_api = 'https://jymd.api.xiaocx.org/Admin';       // 测试环境
const admin_api = 'https://jymd.api.xiaocx.cc/Admin';        // 正式环境

// 万科-测试环境
// const admin_api = 'https://zxlyh-dev-api.onewo.com/Admin';

const upload_url = admin_api + '/Ali_oss/index';
// const upload_url = 'https://zxlyh-api.onewo.com/Admin/Ali_oss/index';

export default {
  upload_url,
  admin_api,
}



// WEBPACK FOOTER //
// ./src/util/common.js